import React from 'react';

import * as Styled from './ImagesContainer.styled';
import { DownloadButtonComponent } from '../DownloadButtonComponent';

type CloseButtonProps = {
  isFullScreen: boolean;
  currentImage: string;
  downloadFileName: string;
  onClose: () => void;
};

export function CloseButton({
  isFullScreen,
  currentImage,
  downloadFileName,
  onClose,
}: CloseButtonProps) {
  return (
    <div style={containerStyle}>
      {isFullScreen && (
        <Styled.CloseFullScreenButton
          dense
          iconName="cross"
          color="secondary"
          onClick={onClose}
        />
      )}
      {isFullScreen ? (
        <DownloadButtonComponent
          imageUrl={currentImage}
          productName={downloadFileName}
          iconType="secondary"
        />
      ) : null}
    </div>
  );
}

///
const containerStyle = {
  maxWidth: '94px',
  position: 'absolute' as const,
  right: 0,
};
